import { RoundButtonWithIcon } from "@/components/tools/RoundButtonWithIcon";
import { ArrowLeftIcon, ArrowRightIcon } from "@heroicons/react/24/solid";

interface ArrowSwitcherProps {
  value: number;
  min: number;
  max: number;
  onChange: (newValue: number) => void;
  labelFormatter?: (value: number) => string | React.ReactNode;
}

export default function ArrowSwitcher({
  value,
  min,
  max,
  onChange,
  labelFormatter,
}: ArrowSwitcherProps) {
  return (
    <div className="mx-auto grid w-full max-w-72 grid-cols-[2.25rem_minmax(5rem,1fr)_2.25rem] items-center gap-3">
      <RoundButtonWithIcon
        icon={ArrowLeftIcon}
        onClick={() => onChange(value - 1)}
        disabled={value <= min}
      />

      <span className="min-w-0 text-center text-3xl font-semibold text-foreground">
        {labelFormatter ? labelFormatter(value) : value}
      </span>
      <RoundButtonWithIcon
        icon={ArrowRightIcon}
        className="justify-self-end"
        onClick={() => value < max && onChange(value + 1)}
        disabled={value >= max}
      />
    </div>
  );
}
